module.exports = __webpack_public_path__ + "img/changan.acf9eea8.jpg";